import axios from "../../service";
import fn from "@/helpers/utility";
import { TopupService } from "../resources";
export const state = {
  keyAuth: {
    key: "topup_flag",
    keyAdvance: "advanced_topup_flag"
  },
  bank: {},
  topup: [],
  topup_package: [],
  topupReport: {
    report: [],
    total: 0
  },
  codReport: {
    report: [],
    total: 0
  }
};

export const mutations = {
  INIT_TOPUUP_VALUE(state, newValue) {
    state.bank = newValue.bank;
    state.topup = newValue.topup;
    state.topup_package = newValue.topup_package;
  },
  INIT_TOPUP_REPORT(state, newValue) {
    state.topupReport.report = newValue.report;
    state.topupReport.total = newValue.total;
  },
  INIT_COD_REPORT(state, newValue) {
    if (newValue.length == 0) {
      state.codReport.report = newValue;
      state.codReport.total = newValue.length;
    } else {
      state.codReport.report = newValue.report;
      state.codReport.total = newValue.total;
    }
  }
};

export const getters = {
  PermissionFlag(state) {
    return fn.PermissionFlag(state.keyAuth.keyAdvance);
  }
};

export const actions = {
  // async fetchTopupData({ commit }) {
  //     try {
  //         let resp = await axios.get("/user/topup");
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //         commit("INIT_TOPUUP_VALUE", resp.data[0]);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  // async topup(_, data) {
  //     try {
  //         let formData = new FormData();
  //         formData.append("file", data.slipPicture);
  //         let resp = await axios.post("/user/topup", formData, {
  //             params: {
  //                 ...data.data,
  //             },
  //             headers: {
  //                 "Content-Type": "multipart/form-data",
  //             },
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง";
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  // async fetchReport({ commit }, data) {
  //     try {
  //         let resp = await axios.get("/user/report/topup", { params: {...data } });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง";
  //         commit("INIT_TOPUP_REPORT", resp.data);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  // async fetchReportTransection({ commit }, data) {
  //     try {
  //         let resp = await axios.get("/user/report/cod/transaction", { params: {...data } });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง";
  //         commit("INIT_COD_REPORT", resp.data);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  async loadPrice({ commit }) {
    try {
      let resp = await TopupService.apiGetLoadPrice()
      return { status: true, ...resp };      
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async bankLoad({ commit }) {
    try {
      let resp = await TopupService.apiGetBankLoad()
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async topUpMoney({ commit }, data) {
    try {
      let resp = await TopupService.apiGetTopUpMoney(data)
      return { status: true, data: resp };
    } catch (err) {
      console.error(err.message, "Error");
      return { status: false, err: err };
    }
  }
};
